import { ContactForm } from './ContactForm';

export type { TypeContactFormProps } from './types';
export default ContactForm;
